import styled from 'styled-components';

const MaximunWidth = styled.div`
  width: ${(props) => props.maxWidth};
`;

export default MaximunWidth;